import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CustomBreadcrumbs from '../../components/common/CustomBreadcrumbs';
import OutputLeftSide from '../../components/feeOutput.js/OutputLeftSide';
import OutputRightSide from '../../components/feeOutput.js/OutputRightSide';
import { selectFeesFormData, selectFeesResponse } from '../../redux-state/selectors';
import { useSelector } from 'react-redux';
import DownloadIcon from '@mui/icons-material/Download';
import SecondaryButton from '../../components/common/button/SecondaryButton';
import PrimaryButton from '../../components/common/button/PrimaryButton';
import { downloadFeesSummaryPdf, uploadFeesSummaryToS3 } from '../../components/utility/feesSummaryPdf';

export default function FeeOutput() {
  const feesFormData = useSelector(selectFeesFormData) || {};
  const navigate = useNavigate();
  const response = useSelector(selectFeesResponse);

  // Archive the summary PDF to S3 as soon as the quote is shown, so it can be
  // redownloaded from Past Transactions whether or not Download is clicked.
  useEffect(() => {
    uploadFeesSummaryToS3(feesFormData, response);
    // Keyed on the transaction: one upload per quote.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response?.["TransactionID"]]);

  const convertToPdf = () => downloadFeesSummaryPdf(feesFormData, response);

  return (
    <div className='p-4 lg:p-8 min-h-[900px]'>
      <div className='flex flex-row justify-between'>
        <div className='mb-4'>
          <CustomBreadcrumbs title={"Fees"} subtitle={"Fees Output"} />
        </div>
        <div>
          <SecondaryButton
            text="Back"
            onClick={() => navigate(-1)}
          />
        </div>
      </div>

      {/* Title and Download share a single row, with the transaction id
          directly beneath, so the header doesn't leave empty bands of
          vertical space above and below the id. */}
      <div className='flex flex-row justify-between items-center gap-4'>
        <div className='text-3xl font-bold text-gray-900'> Fees Output </div>
        {/* Small top margin so Download doesn't butt up against the Back
            button sitting directly above it. */}
        <div className='mt-3'>
          <PrimaryButton
            text={<><DownloadIcon sx={{ mr: '6px' }} /> Download</>}
            onClick={convertToPdf}
          />
        </div>
      </div>
      <div className='text-gray-600 break-all mb-4'> {response["TransactionID"]} </div>

      <div className='flex flex-col xl:flex-row w-full gap-6'>
        <div className='w-full xl:w-1/2 min-w-0'>
          <OutputLeftSide />
        </div>

        <div className="hidden xl:block w-px bg-gray-300" />

        <div className='w-full xl:w-1/2 min-w-0 xl:mt-3'>
          <OutputRightSide />
        </div>
      </div>
    </div>
  );
}